import React from "react"
import store from "src/store"
import ParameterInput from "./parameter-input"
import { useStepIndex } from "./step-index-context"

export default function ChooseBlockNumber() {
  const stepIndex = useStepIndex()

  store.useRerenderIfChange(() => [
    store.steps[stepIndex]?.["customBlockNumber"],
    store.steps[stepIndex]?.["blockNumber"],
  ])

  var customBlockNumber = store.steps[stepIndex]["customBlockNumber"]
  var blockNumber = store.isMainnet? store.blockNumber : (store.steps[stepIndex]["blockNumber"] || 0)

  return (
    <div css="background: white;padding-left:10px;padding-top:10px;">
      <div css="display:flex;">
        <div
          css={`
            width: 110px;
            flex-shrink: 0;
          `}
        >
          Blocknumber
        </div>
        <div
          css={`
            flex-grow: 1;
          `}
        >
          <span css="font-weight: 700">
            {!customBlockNumber && "Default"}
            {customBlockNumber && "Custom"}
            &nbsp;
          </span>
          {!store.isStepReadOnly(stepIndex) && (
            <span
              css={`
                color: #799fd4;
                cursor: pointer;
                text-decoration-line: underline;
                justify-self: right;
                font-size: 13px;
                font-weight: 100;
              `}
              onClick={() => {
                store.removeResults(stepIndex)
                store.steps[stepIndex]["customBlockNumber"] =
                  !store.steps[stepIndex]["customBlockNumber"]
                store.updateStore()
              }}
            >
              Change
            </span>
          )}
        </div>
      </div>
      {customBlockNumber && (
        <>
          <div>
            <ParameterInput
              type="uint256"
              disabled={store.isStepReadOnly(stepIndex)}
              label="Block.blockNumber"
              labelBackground="white"
              showMaxButton = {false}
              onChange={(e) => {
                try {
                  store.removeResults(stepIndex)
                  if(store.isMainnet) {
                    store.blockNumber = parseInt(e.target.value);
                  } else {
                    store.steps[stepIndex]["blockNumber"] = parseInt(e.target.value)
                  }

                  store.updateStore()
                } catch (err) {}
              }}
              value={blockNumber}
            />
          </div>
        </>
      )}
    </div>
  )
}
